window.car_icons = {};

function getCarIcon(point) {
  if (!point.icon && !car_icons.car) {
    //icon为null 并且 car_icons对象中不包含car的icon，那么创建一个新的img对象 并存到car_icons对象中，当下次icon为null时使用
    var img = new Image();
    img.src = "http://webfron.czczh.net/static/car_icon/car.png";
    car_icons.car = img;
  } else if (!point.icon && car_icons.car) {
    //icon为null 但是对象中存在car的icon 那么使用对象中的img对象
    var img = car_icons.car;
  } else if (point.icon && !car_icons[point.icon]) {
    // 如果icon不为null，car_icons中不存在这个icon，创建一个并存到car_icons中
    var img = new Image();
    img.src = `http://webfron.czczh.net/static/car_icon/${point.icon}.png`;
    car_icons[point.icon] = img;
  } else {
    //icon不为null并且car_icons中存在这个icon 那么使用对象中的icon
    var img = car_icons[point.icon];
  }
  return img;
}

function DrawCar(
  map,
  ctx,
  point,
  draw_options,
  tileSty,
  intensity,
  chooseCar,
  drawCarAsCircle
) {
  var sensortype = draw_options.sensortype;
  if (!point[sensortype]) return;
  var drawname = draw_options.drawname;
  var drawSn = draw_options.drawSn;
  var pt = point;
  var pixel = map.pointToPixel(pt);
  var center = { x: pixel.x - 20, y: pixel.y - 20 };
  var zoom = draw_options.zoom;
  if (draw_options.zoom < 12) {
    // 获取绘制图标的大小比例
    let size = getSize(zoom) + 1;
    // 绘制的中心坐标
    center = { x: pixel.x, y: pixel.y };
    if (drawCarAsCircle) {
      // 如果是url是济南的 则画圆
      ctx.beginPath();
      ctx.arc(center.x, center.y, 6, 0, 2 * Math.PI);
      switch (tileSty) {
        case "static":
          ctx.fillStyle = intensity.bgcolor.getColor(point[sensortype]);
          break;
        case "static_stair":
          for (let item of pmcolors) {
            if (
              point[sensortype] >= item["lowval_" + sensortype] &&
              point[sensortype] <= item["highval_" + sensortype]
            ) {
              ctx.fillStyle = item.bgcolor;
              break;
            }
          }
          break;
        case "dynamic":
          ctx.fillStyle = intensity.bgcolor.getColor(point[sensortype]);
          break;
      }
      ctx.fill();
      return;
    } else {
      // 如果url不是济南的，则用字体图标画小车
      // 定义字体，可以使用自定义字体
      ctx.font = `${16 * size}px iconfont`;
      // 字体图表编码转义
      let unicode = eval(
        '("' + "&#xe63b;".replace("&#x", "\\u").replace(";", "") + '")'
      );
      let unicodebg = eval(
        '("' + "&#xe63a;".replace("&#x", "\\u").replace(";", "") + '")'
      );
      // 绘制背景
      ctx.fillStyle = "#333";
      ctx.fillText(unicodebg, center.x, center.y);
      // 绘制前景
      switch (tileSty) {
        case "static":
          ctx.fillStyle = intensity.bgcolor.getColor(point[sensortype]);
          break;
        case "static_stair":
          for (let item of pmcolors) {
            if (
              point[sensortype] >= item["lowval_" + sensortype] &&
              point[sensortype] <= item["highval_" + sensortype]
            ) {
              ctx.fillStyle = item.bgcolor;
              break;
            }
          }
          break;
        case "dynamic":
          ctx.fillStyle = intensity.bgcolor.getColor(point[sensortype]);
          break;
      }
      ctx.fillText(unicode, center.x, center.y);
      return;
    }
  }
  var img = getCarIcon(point);

  if (!car_icons.car_border) {
    var car_border = new Image();
    car_border.src = require("../../assets/img/car_border.png");
    car_icons.car_border = car_border;
  }

  ctx.drawImage(img, center.x, center.y, 30, 30);
  if (chooseCar.sn == point.sn && chooseCar.sn) {
    ctx.drawImage(car_icons.car_border, center.x - 5, center.y - 15, 40, 40);
    map.panTo(new BMap.Point(point.lng, point.lat), { noAnimation: true });
  }
  ctx.beginPath();
  ctx.textAlign = "center";
  ctx.textBaseline = "bottom";
  ctx.font = "12px Arial";
  switch (tileSty) {
    case "static":
      ctx.fillStyle = intensity.bgcolor.getColor(point[sensortype]);
      break;
    case "static_stair":
      for (let item of pmcolors) {
        if (
          point[sensortype] >= item["lowval_" + sensortype] &&
          point[sensortype] <= item["highval_" + sensortype]
        ) {
          ctx.fillStyle = item.bgcolor;
          break;
        }
      }
      break;
    case "dynamic":
      ctx.fillStyle = intensity.bgcolor.getColor(point[sensortype]);
      break;
  }
  let x1 = 0;
  let x2 = 32;

  if (drawname) {
    x2 += 70;
    x1 -= 35;
  }
  if (drawSn) {
    x2 += 70;
    x1 -= 35;
  }
  ctx.fillRect(center.x + x1, center.y - 8, x2, 16);
  var v = point[sensortype];
  ctx.fillStyle = intensity.fgcolor.getColor(point[sensortype]);
  if (v != "--") {
    var value = v > 0 ? parseInt(v) : v.toFixed(0);
  } else {
    value = v;
  }

  var str = value;

  if (drawSn) {
    str = point.sn + "- " + str;
  }
  if (drawname) {
    str = point.CarNo + "- " + str;
  }
  if (point.CameraId) {
    str = "☄" + str;
  }
  ctx.fillText(str, pixel.x - 5, pixel.y - 12);
  ctx.fill();
}

function getSize(zoom) {
  var zoomDict = {
    15: 0.002,
    16: 0.001,
    17: 0.0005,
    18: 0.00025,
    19: 0.00015,
    14: 0.004,
    13: 0.007,
    12: 0.015,
    11: 0.025,
    10: 0.03
  };
  var size = zoomDict[zoom];
  if (!size) {
    size = 0.002;
  }
  return size;
}

function checkTaxi(tar, kuai) {
  var lat = tar.lat,
    lng = tar.lng;
  if (lat < 10 || lng < 10) {
    return;
  }
  for (var i in kuai) {
    if (
      lat < kuai[i][0][1] &&
      lat > kuai[i][1][1] &&
      lng < kuai[i][1][0] &&
      lng > kuai[i][0][0]
    ) {
      var point = kuai[i][2];
      return point;
    }
  }
  return 0;
}

export { getSize, DrawCar, checkTaxi };
